<template>
    <div>
        <Modal v-model="modelShow" title="选择收货地址" width="800" @on-cancel="cancel">
            <Form :model="formValue" :label-width="80" inline>
                <FormItem label="详细地址">
                    <Input v-model="formValue.addressLike" clearable style="width:200px" />
                </FormItem>
                <Button type="primary" @click="onSelect">查询</Button>

            </Form>
            <data-grid v-if="dataShow" ref="lg" :columns="cols" :pagination="false" :autoLoad="false" subListName :dataList="dataList">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px" highlight-row @on-current-change="onCurrentChange">
                          <template #option="{row,index}">
                            <Button type="error" size="small" @click="onError(row.id)">删除</Button>
                        </template>
                    </Table>
                </template>
            </data-grid>
            <div slot="footer">
                <Button type="primary" size="small" @click="submit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import dataGrid from '@/components/datagrid.vue'

export default {
    components: {
        dataGrid
    },
    data() {
        return {
            modelShow: false,
            dataShow: false,
            dataList: [],
            formValue: {
                memberId: "",
                addressLike: ""
            },
            row: {},
            cols: [
                { title: '租借人', key: "memberId", dict: ['bizObjects', 'member', true] },
                { title: '所在区域', key: "areaId", dict: ['region', 'fullArea', true] },
                { title: '详细地址', key: "address" },
                { title: '联系人', key: "contactName" },
                { title: '手机号', key: "contactMobile" },
                { title: '邮箱', key: "contactEmail" },
                { title: '证件号', key: "contactIdentityNo" },
                { title: "操作", slot: "option" }
            ]
        }
    },
    methods: {
        // 删除
        onError(id){
             this.$Modal.confirm({
                    title: '确定删除吗?',
                    onOk: () => {
                        let data = {
                            url:"http://CORE-MEMBER/messageService/contactService/deleteMemberAddress",
                            body:{id}
                        }
                        this.invoke(data).then(res=>{
                            this.$Message.success('删除成功')
                            this.getData()
                        })
                        
                    },
                });
        },
        openModal(memberId) {
            this.modelShow = true;
            this.formValue.memberId = memberId;
            this.getData();

        },
        cancel() {
            this.formValue.addressLike = "";
            this.modelShow = false;
            this.row = {};

        },
        getData() {
            let data = {
                url: 'CORE-MEMBER/messageService/contactService/queryMemberAddressListByMemberId',
                body: { memberId: this.formValue.memberId, addressLike: this.formValue.addressLike }
            }
            this.dataShow = false
            this.invoke(data).then(res => {
                this.dataList = res;
                this.dataShow = true;
            }).catch(err => {
                this.dataShow = true
            })
        },
        onSelect() {
            this.getData()
        },
        onCurrentChange(currentRow) {
            this.row = currentRow
        },
        submit() {
            if (this.row.areaId) {
                this.$emit('onRow', this.row)
                this.cancel()
            } else {
                this.$Message.error('请选择地址')
            }
        }
    }

}
</script>

<style lang="scss" scoped>
</style>